import { createStore } from "vuex";

export default createStore({
  state: {
    scopes: window.scopes || [],
    domain: window.domain || "",
    notary: null,
    self_user: null,
  },

  mutations: {
    SET_SCOPES(state, payload) {
      state.scopes = payload.value;
    },
    SET_DOMAIN(state, domain) {
      state.domain = domain;
    },
    SET_NOTARY(state, notary) {
      state.notary = notary;
    },
    SET_SELF_USER(state, user) {
      state.self_user = user;
    },
  },
  actions: {},
  modules: {},
  getters: {
    get_domain: (state) => {
      return state.domain;
    },
    has_access: (state) => (scope) => {
      if (!scope) return true;

      const scopes = state.scopes || [];

      if (typeof scope === "string") {
        return scopes.includes(scope);
      }

      if (Array.isArray(scope)) {
        return scope.every((s) => scopes.includes(s));
      }

      return false;
    },
    get_notary: (state) => {
      return state.notary;
    },
    get_self_user: (state) => {
      return state.self_user;
    },
  },
});
